'use client';
import { LiveChatWidget, WidgetConfig } from '@livechat/widget-react';

import { LIVE_CHAT_LICENSE } from '@/decodo/components/organisms/SocialWidget/license';

type LiveChatProps = Omit<WidgetConfig, 'license'>;

function LiveChat(props: LiveChatProps) {
  return (
    <LiveChatWidget
      {...props}
      license={LIVE_CHAT_LICENSE}
      onReady={props.onReady}
    />
  );
}

export default LiveChat;
